<template lang="pug">
  v-app-bar.z-index-1.ma-0(
    :color="color"
    app
    flat
    height="60"
    :dark="isDark"
  )
    v-container.d-flex.align-center
      v-btn.d-sm-none.mx-0(
        v-if="isAuthenticated"
        text icon small
        @click="$store.dispatch('SET_DRAWER', true)"
      ): v-icon mdi-menu

      v-col(v-if="!isAuthenticated" cols=3 sm=8)
        router-link(to="/")
          v-img.my-2.ml-md-2(
            :src="require(`@/assets/logo${logoPrefix}.svg?inline`)"
            height="40"
            contain
            position="left center"
          )
      //- TODO: Убрать 'Тестовый регион' когда у всех пользователей в базе будут регионы.
      //- v-chip.d-none.d-sm-block.caption(v-else) {{ userRegion.name || 'Тестовый регион' }}
      .ml-2(v-if="$user.isAuthenticated")
        notification-badge
      v-spacer
      template(
        v-if="!$user.data"
      )
        v-btn(
          to="/sign-in"
          depressed
          rounded
          text
        )
          v-icon(left) mdi-account
          | Вход в систему

      v-menu(
        v-if="$user.data"
        transition="slide-y-reverse-transition"
        bottom left offset-y
      )
        template(v-slot:activator="{ on, attrs, value }")
          v-btn(
            v-on="on"
            depressed rounded text
          )

            .text-body-2 Id: {{ userData.number }}
            v-avatar(color="secondary" size="28" class="ml-2")
              span(class="white--text") {{ firstLetterName }}
            v-icon(right) {{ value ? 'mdi-chevron-down' : 'mdi-chevron-down' }}
        v-list(dense).px-1
          //- span.hidden-sm-and-down
          .mx-4.mt-2.mb-4.text-body-2: strong
            v-avatar.mr-2(color="secondary" size="24"): v-icon(small color="white") mdi-account
            span.mt-1
              | {{ userData.info.surname }}
              | {{ userData.info.first_name }}
              | {{ userData.info.patronymic }}

          v-list-item(:to="{ name: 'UserSettings' }")
            v-list-item-title
              v-icon(left) mdi-cogs
              | Настройки
          v-list-item.mb-2(
            v-if="$user.isOrganization"
            :to="{ name: 'AuthorizeSecond' }"
        )
            v-list-item-title
              v-icon(left ) mdi-account-group
              | Список слушателей
          v-btn.my-2(
            v-if="$user.isListener"
            @click="wantToTeach" color="primary" outlined block
          )
            v-icon(left ) mdi-account
            | Хочу преподавать
          v-divider(class="mx-4 mb-1")
          v-list-item(@click="logout" :disabled="loadings.logout")
            v-list-item-title
              v-icon(left) mdi-account-cancel
              | Выйти

</template>

<script>
import { mapActions, mapGetters } from 'vuex';

import NotificationBadge from '@/components/Layout/NotifcationBadge.vue';
import SignInForm from '@/modules/Auth/components/SignInForm.vue';

export default {
  name: 'TheAppBar',
  components: {
    SignInForm,
    NotificationBadge,
  },
  props: {
    drawer: {
      type: Boolean,
      default: true,
    },
  },
  data: () => ({
    showSignInForm: false,
    loadings: {
      logout: false,
    },
  }),
  computed: {
    ...mapGetters({
      isAuthenticated: 'auth/isAuthenticated',
      userData: 'auth/userData',
      userRegion: 'auth/userRegion',
      darkTheme: 'darkTheme',
    }),
    isHomepage() {
      return this.$route.path === '/';
    },
    isDark() {
      return !this.isAuthenticated;
    },
    color() {
      if (!this.isAuthenticated && this.isHomepage) {
        return '#7a6677';
      }
      if (this.isAuthenticated) {
        return 'white';
      }
      return 'secondary';
    },
    logoPrefix() {
      if (this.$vuetify.breakpoint.xs) return '';
      return this.isDark ? '-white' : '-dark';
    },
    firstLetterName() {
      const { info } = this.userData;
      if (info && info.patronymic) return info.patronymic[0];
      return this.userData.name[0];
    },
  },
  methods: {
    ...mapActions({ LOGOUT: 'auth/LOGOUT' }),
    async wantToTeach() {
      this.$modals.show('confirm-controller', {
        title: 'Действительно ли вы хотите изменить свою роль на учителя?',
        message: 'После изменения роли обратное изменение будет невозможно',
        dialogProps: {
          width: 800,
        },
        method: async () => {
          await this.$api.auth.transformToTeacher();
          await this.$user.syncUser();
          this.$modals.close();
        },
      });
    },
    async logout() {
      this.$loader.start();
      await this.LOGOUT();
      if (this.$route.path !== '/') this.$router.push({ name: 'Home' });
      this.loadings.logout = false;
      this.$loader.stop();
    },
  },
};
</script>
<style lang="scss" scoped>
::v-deep .v-toolbar__content {
  padding: 4px 8px !important;
}
</style>
